<template>
  <div class="ih-page-not-found ih-page">
    <h2 class="text-center">404</h2>
  </div>
</template>



<script>
export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {},

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/pages/PageNotFound";
</style>
